import ApiClient from './apiClient';
import {
  BackendRedeemItem,
  RedeemApiResponse as TypesRedeemApiResponse,
} from 'types/dto/redeem';

export const fetchRedeemItems = async (
  page = 1
): Promise<TypesRedeemApiResponse> => {
  const response = await ApiClient.getInstance().get({
    url: 'redeem/getredeemitems',
    params: {
      code: '',
      page,
    },
  });
  return response.data?.data;
};

export const fetchRedeemItemDetail = async (
  code: string
): Promise<BackendRedeemItem> => {
  const response = await ApiClient.getInstance().get({
    url: 'redeem/getredeemitems',
    params: {
      code,
      page: 1
    },
  });
  return response.data?.data;
};

export const redeemItem = async (code: string, costId: number) => {
  const response = await ApiClient.getInstance().get({
    url: 'redeem/redeemitem',
    params: {
      code,
      cost_id: costId,
    },
  });
  return response.data?.data;
};
